<template>
  <v-flex sm6 md4 lg4>
    <div class="layout column align-center mb-3">
      <img src="/img/logo.png" alt="Logotipo de Patronato Cultural Vizcaya" width="150" height="150">
    </div>
    <v-card raised>
      <v-toolbar dark color="primary" flat dense>
        <div class="layout column align-center">
          <v-toolbar-title>
            Acceder a {{ appName }}
          </v-toolbar-title>
        </div>
      </v-toolbar>
      <v-card-text>
        <login-form @success="success"></login-form>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
  export default {
    data() {
      return {
        appName: process.env.VUE_APP_APP_NAME
      }
    },

    components: {
      'login-form': require('./LoginForm').default
    },

    methods: {
      success(data) {
        this.$store.dispatch('auth/saveToken', data)
        this.$store.dispatch('auth/setUser', data)
        this.$router.push({ name: 'index' })
      }
    }
  }
</script>
